import React, {useEffect, useState} from "react";
import { useLocation } from "react-router-dom";
import AccountSpecificTable from "./AccountSpecificTable";
import Loader from "../../../../components/Loader/Loader";
import './report.css';
import logo from "../../../../assets/img/profile/Emblem_of_Angola.png"
export const FINANCIAL_HEAD = process.env.REACT_APP_FINANCIAL_HEAD;
export const EMBAIXADOR = process.env.REACT_APP_EMBAIXADOR;
export const COUNTRY = process.env.REACT_APP_COUNTRY;

const AccountSpecificReport = () => {
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState({});
  const [reportData, setReportData] = useState([]);
  const [footerData, setFooterData] = useState({});
  const [initialBalanceData, setInitialBalanceData] = useState([]);
const [despesaData, setDespesaData] = useState([]);
const [accountNumberData, setAccountNumberData] = useState([]);

const [recitaData, setRecitaData] = useState([]);
const [remainingBalanceData, setRemainingBalanceData] = useState([]);
const [groupedInitialBalanceData, setGroupedInitialBalanceData] = useState([]);
const [groupedDespesaData, setGroupedDespesaData] = useState([]);
const [groupedRecitaData, setGroupedRecitaData] = useState([]);
const [groupedRemainingBalanceData, setGroupedRemainingBalanceData] = useState([]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Extract query parameters
  const accountId = queryParams.get("accountId");
  const yearMonth = queryParams.get("yearMonth");
  const accountNumber = queryParams.get("accountId");
  const bankName = queryParams.get("accountId");


  useEffect(() => {
    fetchbankReport(accountId, yearMonth);
  }, []);

  const fetchbankReport = async (accountId, yearMonth) => {
    setLoading(true);
  try {
    let apiUrl = `${process.env.REACT_APP_API_URL}/v1/reports/account-data?accountId=${accountId}&yearMonth=${yearMonth}`;
    const userToken = localStorage.getItem("token");
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    });
    setLoading(false);

    if (response.ok) {
      const responseData = await response.json();
      if (responseData.data) {
        const processedData = processData(responseData.data);
        const groupedsData = groupedProcessData(responseData.data);
        setAccountNumberData(responseData.data.accountNumber);
        setInitialBalanceData(processedData.initialBalanceData);
        setDespesaData(processedData.despesaData);
        setRecitaData(processedData.recitaData);
        setRemainingBalanceData(processedData.remainingBalanceData);


        setGroupedInitialBalanceData(groupedsData.groupedInitialBalanceData);
        setGroupedDespesaData(groupedsData.groupedDespesaData);
        setGroupedRecitaData(groupedsData.groupedRecitaData);
        setGroupedRemainingBalanceData(groupedsData.groupedRemainingBalanceData);
      }
    } else {
      console.error('Error fetching API data:', response.status);
    }
  } catch (error) {
    setLoading(false);
    console.error('Error fetching API data:', error);
  }
  }
  const processData = (apiData) => {
    if (!apiData) return;
  
    // Form data for "Initial Balance"
    const initialBalanceData = [
      { descricao: 'Saldo Inicial', amount: apiData.initialBalance },
    ];
  
    // Form data for "Despesa"
    const despesaData = [
      { descricao: 'Despesas', amount: apiData.sumDespesa },
    ];
  
    // Form data for "Recita"
    const recitaData = [
      { descricao: 'Entradas', amount: apiData.sumRecita},
    ];
  
    // Form data for "Remaining Balance"
    const remainingBalanceData = [
      { descricao: 'Saldo Final', amount: apiData.remainingBalance },
    ];
  
    return { initialBalanceData, despesaData, recitaData, remainingBalanceData };
  };
  

 // Function to process the API response data
 const groupedProcessData = (data) => {
  // Replace null values with 0 in groupedData
  const processedGroupedData = data.groupedData.map(org => ({
    ...org,
    groupedInitialBalance: org.groupedInitialBalance ?? 0,
    groupedDespesa: org.groupedDespesa ?? 0,
    groupedRecita: org.groupedRecita ?? 0,
    groupedRemainingBalance: org.groupedRemainingBalance ?? 0,
  }));

  const groupedInitialBalanceData = processedGroupedData.map((org) => ({
    descricao: org.organizationName,
    amount: org.groupedInitialBalance,
  }));
  const groupedDespesaData = processedGroupedData.map((org) => ({
    descricao: org.organizationName,
    amount: org.groupedDespesa,
  }));
  const groupedRecitaData = processedGroupedData.map((org) => ({
    descricao: org.organizationName,
    amount: org.groupedRecita,
  }));
  const groupedRemainingBalanceData = processedGroupedData.map((org) => ({
    descricao: org.organizationName,
    amount: org.groupedRemainingBalance,
  }));

  return {
    groupedInitialBalanceData,
    groupedDespesaData,
    groupedRecitaData,
    groupedRemainingBalanceData,
  };
};



  const handlePrint = () => {
    window.print();
  };

  const formatYearMonth = (yearMonth) => {
    // Parse the yearMonth string
    const [year, month] = yearMonth.split('-');
    
    // Create a date object
    const date = new Date(year, month - 1); // JavaScript months are 0-based
    
    // Format the month name in Portuguese
    return new Intl.DateTimeFormat('pt-BR', { month: 'long', year: 'numeric' }).format(date);
  };

  return (
    
   <div className="p-2">
       <Loader show={loading}/>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-4 text-black dark:text-white">
          <div className="flex-1 text-center">
          <div className="flex items-center justify-center h-[100px]">
  <img
    src={logo}
    alt="Logo"
    className="w-[60px] h-[80px] object-contain"
  />
</div>
            <h1 className="text-xl font-bold">REPÚBLICA DE ANGOLA</h1>
            <h2 className="text-md">MINISTÉRIO DAS RELAÇÕES EXTERIORES</h2>
            <h2 className="text-md">EMBAIXADA DA REPÚBLICA DE ANGOLA NO {COUNTRY}</h2>
            <h2 className="text-md font-bold mt-5">SALDO DISPONÍVEL(BANCO)</h2>
            <h2 className="text-md">MÊS DE {formatYearMonth(yearMonth)}</h2>
          </div>

          <div className="text-right">
            <p className="text-md">Nº DA CONTA: {accountNumberData}</p>
            {/* <p className="text-md">Nome: {bankName}</p> */}
          </div>
        </div>

        {/* Print Button */}
        <div className="text-right mb-4">
          <button
            onClick={handlePrint}
            className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 print:hidden">
            Print
          </button>

        </div>

        {/* Table */}
        {processData?.length >= 0 && (
            <AccountSpecificTable
                tableData={initialBalanceData}
                tableName="Saldo Inicial"
            />
            
        )}
        {processData?.length >= 0 && (
            <AccountSpecificTable
                tableData={recitaData}
                tableName="Entradas"
            />
            
        )}

{processData?.length >= 0 &&  (
            <AccountSpecificTable
                tableData={despesaData}
                tableName="Saídas"
            />
            
        )}
        {processData?.length >= 0 && (
            <AccountSpecificTable
                tableData={remainingBalanceData}
                tableName="Saldo Final"
            />
            
        )}
        {/* Footer */}
        <div className="flex justify-between mt-10">

        <div>
            <p>Encarregado de Serviço</p>
            <hr className="mt-5 border-t-2 my-2" style={{ borderTop: '2px solid black' }} />

          </div>
          <div>
            <p className="text-center">Adido Financeiro</p>
            <p className="font-bold"> {FINANCIAL_HEAD} </p>
            <hr className="mt-5 border-t-2 my-2" style={{ borderTop: '2px solid black' }} />

          </div>
          <div>
            <p className="text-center">Visto Embaixadora</p>
            <p className="font-bold">{EMBAIXADOR}</p>
            <hr className="mt-5 border-t-2 my-2" style={{ borderTop: '2px solid black' }} />
          </div>
        </div>
        <div className="print-page-break"></div>


<div className="flex justify-between items-center mb-4 text-black dark:text-white print:pt-10 mt-40">
<div className="flex-1 text-center">
<div className="flex items-center justify-center h-[100px]">
  <img
    src={logo}
    alt="Logo"
    className="w-[60px] h-[80px] object-contain"
  />
</div>
<h1 className="text-xl font-bold">REPÚBLICA DE ANGOLA</h1>
<h2 className="text-md">MINISTÉRIO DAS RELAÇÕES EXTERIORES</h2>
<h2 className="text-md">EMBAIXADA DA REPÚBLICA DE ANGOLA NO {COUNTRY}</h2>
<h2 className="text-md font-bold mt-5">SALDO CONTA CONJUNTA</h2>
<h2 className="text-md">MÊS DE {formatYearMonth(yearMonth)}</h2>
</div>

<div className="text-right">
<p className="text-md">Nº DA CONTA: {accountNumberData}</p>
{/* <p className="text-md">Nome: {apiData.accountName}</p> */}
</div>



</div>
  {/* Table */}
  {groupedInitialBalanceData?.length >= 0 &&  (
            <AccountSpecificTable
                tableData={groupedInitialBalanceData}
                tableName="Saldo Inicial"
            />
            
        )}
        {groupedRecitaData?.length >= 0 &&  (
            <AccountSpecificTable
                tableData={groupedRecitaData}
                tableName="Entradas"
            />
            
        )}

{groupedDespesaData?.length >= 0 &&(
            <AccountSpecificTable
                tableData={groupedDespesaData}
                tableName="Saídas"
            />
            
        )}
        {groupedRemainingBalanceData?.length >= 0 && (
            <AccountSpecificTable
                tableData={groupedRemainingBalanceData}
                tableName="Saldo Final"
            />
            
        )}
        {/* Footer */}
        <div className="flex justify-between mt-10">

        <div>
            <p>Encarregado de Serviço</p>
            <hr className="mt-5 border-t-2 my-2" style={{ borderTop: '2px solid black' }} />

          </div>
          <div>
          <p className="text-center">Adido Financeiro</p>
          <p className="font-bold">{FINANCIAL_HEAD}</p>
            <hr className="mt-5 border-t-2 my-2" style={{ borderTop: '2px solid black' }} />

          </div>
          <div>
          <p className="text-center">Visto Embaixadora</p>
          <p className="font-bold">{EMBAIXADOR}</p>
            <hr className="mt-5 border-t-2 my-2" style={{ borderTop: '2px solid black' }} />
          </div>
        </div>

      </div>
               
        
    </div>
  );
};

export default AccountSpecificReport;
